export default {
  id: 240,
  title: 'Target #240 - Snapshot',
  url: 'https://cssbattle.dev/play/240',
  colors: ['#558C90', '#325853', '#F4DA64'],
  solution:
    '<p a><p b><p c><p d><p e><style>p[a],p[c]{background:#325853}p[d],p[e]{width:20;background:#558c90}body,p[b],p[d],p[e]{background:#558c90}p{position:fixed;margin:0}p[a]{top:50;left:110;width:180;height:200;border-radius:40px}p[b]{top:130;left:110;width:40;height:40;box-shadow:140px 0 #558c90}p[c]{top:110;left:150;width:60;height:60;border-style:solid;border-color:#f4da64;border-width:10px 20px}p[d]{top:50;left:190;height:90;box-shadow:0 110px #558c90}p[e]{top:140;left:170;height:20;box-shadow:40px 0 #558c90',
}
